import { render, staticRenderFns } from "./RunnitsOwnerSelectionCard.vue?vue&type=template&id=196d2ae2"
import script from "./RunnitsOwnerSelectionCard.vue?vue&type=script&lang=ts"
export * from "./RunnitsOwnerSelectionCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports